
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/financial-insights",
      function () {
        return require("private-next-pages/docs/financial-insights.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/financial-insights"])
      });
    }
  